"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultIdentityIdStore = exports.CognitoAWSCredentialsAndIdentityIdProvider = exports.cognitoCredentialsProvider = void 0;
const core_1 = require("@aws-amplify/core");
const IdentityIdStore_1 = require("./IdentityIdStore");
Object.defineProperty(exports, "DefaultIdentityIdStore", { enumerable: true, get: function () { return IdentityIdStore_1.DefaultIdentityIdStore; } });
const credentialsProvider_1 = require("./credentialsProvider");
Object.defineProperty(exports, "CognitoAWSCredentialsAndIdentityIdProvider", { enumerable: true, get: function () { return credentialsProvider_1.CognitoAWSCredentialsAndIdentityIdProvider; } });
/**
 * Cognito specific implmentation of the CredentialsProvider interface
 * that manages setting and getting of AWS Credentials.
 *
 * @throws configuration expections: `InvalidIdentityPoolIdException`
 *  - Auth errors that may arise from misconfiguration.
 * @throws service expections: {@link GetCredentialsForIdentityException}, {@link GetIdException}
 *
 */
exports.cognitoCredentialsProvider = new credentialsProvider_1.CognitoAWSCredentialsAndIdentityIdProvider(new IdentityIdStore_1.DefaultIdentityIdStore(core_1.defaultStorage));
